import React from 'react';

import ErrorScreen from 'components/ErrorScreen/ErrorScreen';
import { useGlobalStore } from 'store';

import * as Styled from './WebGLDisabled.styles';

const WebGLDisabledProps = () => {
  const { isError } = useGlobalStore();

  return (
    <Styled.Wrapper>
      <ErrorScreen visible={isError} errorType="webGL" />
    </Styled.Wrapper>
  );
};

export default WebGLDisabledProps;
